import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Fab,
  Grid,
  Typography,
} from '@mui/material';
import Download from '@mui/icons-material/Download';
import { COLOR_PRIMARY } from 'src/const';
import {
  makeDownloadableBlob,
} from 'src/utils/functions';
import IndividualMarketView from './IndividualMarketView';


const DownloadCSV = ({ setDownloadCSVModalOpen, handleDownloadCsv }) => {

  return (
    <Dialog open={true} sx={{ '& .MuiPaper-root': { width: '400px' } }}>
      <DialogTitle id="alert-dialog-title">{'Download CSV'}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">Download CSV</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setDownloadCSVModalOpen(false);
          }}
        >
          Cancel
        </Button>
        <Button onClick={handleDownloadCsv} autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const RegionUpdateDashboard = ({
  uploadedCsv,
  updatedCsv,
  setUpdatedCsv,
  marketSuggessionCacheStorage,
}: {
  uploadedCsv: { [key: string]: string }[];
  updatedCsv: { [key: string]: string };
  setUpdatedCsv: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>;
  marketSuggessionCacheStorage: any;
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [downloadCSVModalOpen, setDownloadCSVModalOpen] = useState(false);

  const region = uploadedCsv[currentIndex];

  const goToNextRegion = () => {
    setCurrentIndex(prev => {
      if (prev + 1 === uploadedCsv.length) {
        setDownloadCSVModalOpen(true);
      }
      return Math.min(prev + 1, uploadedCsv.length - 1);
    });
  };

  const goToPrevRegion = () => {
    setCurrentIndex(prev => Math.max(prev - 1, 0));
  };

  const handleDownloadCsv = () => {
    let csvArray: string = '';
    csvArray += 'city, country_code, updated_district, updated_city, id\n';
    for (const marketIndex in updatedCsv) {
      csvArray += '"' + uploadedCsv[marketIndex].city + '"' + ',';
      for (const key of ['countryCode', 'district', 'city', 'id']) {
        csvArray += '"' + updatedCsv[marketIndex][key] + '"' + ',';
      }
      csvArray += '\n';
    }

    makeDownloadableBlob(csvArray, 'csv_file', false, true);
  };

  return (
    <>
      <Grid container sx={{ padding: '20px' }}>
        <Grid container sx={{ background: '', height: '100%', width: '100%' }}>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant='h6' sx={{marginBottom: '10px'}}>
                {currentIndex + 1}<span style={{color: COLOR_PRIMARY}}>/{uploadedCsv.length}</span>
              </Typography>
            </Grid>
            <Grid item container xs={8} justifyContent="flex-start">
              <Typography variant="body1" sx={{ fontSize: '20px' }}>
                Target Region:{' '}
                <span style={{ color: COLOR_PRIMARY, fontWeight: 'bold', marginRight: '20px' }}>
                  {region.city}
                </span>
                Country Code:{' '}
                <span style={{ color: COLOR_PRIMARY, fontWeight: 'bold' }}>
                  {region.countryCode}
                </span>
              </Typography>
            </Grid>
            <Grid item container spacing={2} xs={4} justifyContent="flex-start">
              <Grid item>
                <Button variant="contained" onClick={() => goToPrevRegion()}>
                  Previous
                </Button>
              </Grid>
              <Grid item>
                <Button variant="contained" onClick={() => goToNextRegion()}>
                  Next
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <IndividualMarketView
            region={region}
            goToNextRegion={goToNextRegion}
            currentIndex={currentIndex}
            setUpdatedCsv={setUpdatedCsv}
            marketSuggessionCacheStorage={marketSuggessionCacheStorage}
          />
        </Grid>
      </Grid>

      <Fab
        color="info"
        aria-label="download"
        onClick={handleDownloadCsv}
        sx={{ position: 'absolute', top: '10px', right: '10px' }}
      >
        <Download />
      </Fab>

      {downloadCSVModalOpen && (
        <DownloadCSV
          handleDownloadCsv={handleDownloadCsv}
          setDownloadCSVModalOpen={setDownloadCSVModalOpen}
        />
      )}
    </>
  );
};

export default RegionUpdateDashboard;
